module.exports = __webpack_public_path__ + "img/climbing-list.f3ff8239.svg";